@if (!(hideNavigation$ | async)) {
  <button
    (click)="close()"
    class="close"
    disableRipple="true"
    mat-icon-button
    tabindex="1000"
    >
    <mat-icon>close</mat-icon>
  </button>
}
<div #fullscreen class="fullscreen">
  @if (currentPhoto$ | async; as currentPhoto) {
    <lib-image-loader
      (imageLoaded)="urlLoaded.emit({ index: currentIndex, url: $event.src })"
      [fullscreenZoom]="true"
      [hasZoom]="true"
    [url]="
      currentPhoto
        | getImageUrl
          : currentPhoto.photoGroupId
          : 'anyone'
          : context
          : contextId
          : 2000
          : (currentPhoto.photoGroupId | getGroupWatermarkHash: 'anyone')
          : false
        | async
    "
    ></lib-image-loader>
  }
  @if (!(hideNavigation$ | async)) {
    <span (click)="next()" class="right"
      ><mat-icon>chevron_right</mat-icon></span
      >
      <span (click)="prev()" class="left"><mat-icon>chevron_left</mat-icon></span>
    }
  </div>
